import React from 'react';
import { Form, Field } from 'react-final-form';

import FormField, { FormError } from 'components/Form/FormField';
import {
  required,
  isArray,
  isUrl,
  composeValidators,
} from 'utils/formValidators';

import CategorySelectField from 'components/Form/categorySelectField';
import BusinessLogo from './businessLogo';
import BusinessApi from '../../../apis/Business';

const BasicInfoForm = ({
  name,
  website,
  description,
  categories,
  cancelEdit,
  onSubmit,
}) => {
  const initialValues = {
    name,
    website,
    description,
    categories: categories.map(category => {
      const array = { label: category.name, value: category.id };
      return array;
    }),
  };

  return (
    <div className="p-3 business-basic-info">
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, form, submitting }) => (
          <form name="customSurveyEditForm" onSubmit={handleSubmit}>
            <FormField
              name="name"
              inputClassName="form-control mt-2"
              placeholder="Business Name"
              validate={required}
            />
            <FormField
              name="website"
              placeholder="Business Website"
              inputClassName="form-control mt-2"
              validate={composeValidators(required, isUrl)}
            />
            <hr />
            <FormField
              name="description"
              placeholder="Short description"
              inputClassName="form-control"
              textArea
              rows={5}
              validate={required}
            />
            <Field
              name="categories"
              validate={composeValidators(required, isArray)}
            >
              {({ input }) => (
                <div className="mt-2">
                  <CategorySelectField {...input} />
                  <FormError name={input.name} />
                </div>
              )}
            </Field>
            <div className="d-flex justify-content-evenly btn-container">
              <button
                className="btn btn-light"
                disabled={submitting}
                onClick={() => {
                  form.reset();
                  cancelEdit();
                }}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                disabled={submitting}
                onClick={handleSubmit}
                type="submit"
              >
                Save
              </button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default BasicInfoForm;



// WEBPACK FOOTER //
// ./src/components/businessDetail/basicInfo/basicInfoForm.js